/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { Space, Table, Transfer } from "antd";
import type {
  ColumnsType,
  FilterValue,
  TableRowSelection,
} from "antd/es/table/interface";
import type { TransferProps } from "antd/es/transfer";
import difference from "lodash/difference";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import {
  midserviceInstansesListAsync,
  selectMidservicesList,
} from "../../redux/slices/midservice/midserviceSlice";
import {
  type PaginationParams,
  type MidserviceType,
  MidserviceStatus,
} from "../../redux/slices/midservice/midserviceTypes";
import { Link } from "react-router-dom";
import {
  selectCurrentConfiguration,
  // selectSelectedInstances,
  // setSelectedInstances,
} from "../../redux/slices/PacketConfiguration/PacketConfigurationSlice";
import { filtersToQueryString } from "../../utils/filter";

interface TableTransferProps extends TransferProps<MidserviceType> {
  dataSource: MidserviceType[];
  currentConfigHash?: string;
  packetConfigId?: number;
  leftColumns: ColumnsType<MidserviceType>;
  rightColumns: ColumnsType<MidserviceType>;
}

// Customize Table Transfer
const TableTransfer = ({
  leftColumns,
  rightColumns,
  currentConfigHash,
  packetConfigId,
  ...restProps
}: TableTransferProps): JSX.Element => {
  return (
    <Transfer {...restProps}>
      {({
        direction,
        filteredItems,
        onItemSelectAll,
        onItemSelect,
        selectedKeys: listSelectedKeys,
        // disabled: listDisabled,
      }) => {
        console.log("listSelectedKeys", listSelectedKeys);
        const columns = direction === "left" ? leftColumns : rightColumns;

        const ColorfulRow = ({
          index,
          instance,
          className,
          style,
          ...restProps
        }: ColorfulRowProps): JSX.Element => {
          if (instance == null) return <tr {...restProps} />;
          let styles = {};
          console.log("ColorfulRow", instance, index, currentConfigHash);
          //
          if (instance.online === MidserviceStatus.OFFLINE) {
            styles = { backgroundColor: "#f0f0f0", color: "#8c8c8c" };
          } else if (
            direction === "right" &&
            currentConfigHash != null &&
            instance.configPatchHashes != null &&
            packetConfigId != null &&
            instance.configPatchHashes[packetConfigId] === currentConfigHash
          ) {
            styles = { backgroundColor: "#d9f7be" };
          }
          return <tr style={styles} {...restProps} />;
        };

        const components = {
          body: {
            row: ColorfulRow,
          },
        };

        const rowSelection: TableRowSelection<MidserviceType> = {
          // getCheckboxProps: (item) => ({
          //   disabled: listDisabled ?? item.disabled,
          // }),
          onSelectAll(selected, selectedRows) {
            const treeSelectedKeys = selectedRows
              // .filter((item) => !(item.disabled ?? false))
              .map(({ id }) => String(id));
            const diffKeys = selected
              ? difference(treeSelectedKeys, listSelectedKeys)
              : difference(listSelectedKeys, treeSelectedKeys);
            onItemSelectAll(diffKeys, selected);
          },
          onSelect(item, selected) {
            console.log("row id", item.id, selected);
            onItemSelect(String(item.id), selected);
          },
          selectedRowKeys: listSelectedKeys,
        };

        return (
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={filteredItems}
            components={components}
            // components={components}s
            size="small"
            // style={{ pointerEvents: listDisabled ?? false ? "none" : undefined }}
            onRow={(instance, index) => ({
              onClick: () => {
                // if ((itemDisabled ?? false) || (listDisabled ?? false)) return;
                onItemSelect(
                  String(instance.id),
                  !listSelectedKeys.includes(String(instance.id)),
                );
              },
              index,
              instance,
            })}
          />
        );
      }}
    </Transfer>
  );
};

const columns: ColumnsType<MidserviceType> = [
  {
    title: "Идентификатор",
    dataIndex: "deviceId",
    key: "deviceId",
    render: (text, record) => (
      <Space size="middle">
        <Link to={`/instances/${record.id}`} key="list-loadmore-edit">
          {text}
        </Link>
      </Space>
    ),
  },
  {
    title: "Название",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "ТТ",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Версия",
    dataIndex: "version",
    key: "version",
  },
];

interface ColorfulRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  index: number;
  instance: MidserviceType;
}

interface InstancesTransferProps {
  domain: string;
  networkId: number;
  value?: string[];
  onChange?: () => void;
}

export const InstancesTransfer: React.FC<InstancesTransferProps> = ({
  domain,
  networkId,
  value,
  onChange,
}: InstancesTransferProps): JSX.Element => {
  // const [targetKeys, setTargetKeys] = useState<string[]>([]);
  // const selectedInstances = useAppSelector(selectSelectedInstances);
  const currentConfiguration = useAppSelector(selectCurrentConfiguration);

  // const [filter, setFilter] = useState<Record<string, FilterValue | null>>({
  //   network: [networkId],
  //   instanceType: ["MIDSERVICE"],
  //   domain: [domain],
  // });
  // console.log("InstancesTransfer fff", domain, networkId, filter);

  // const [disabled, setDisabled] = useState(false);
  // const [showSearch, setShowSearch] = useState(false);

  // const onChange = (nextTargetKeys: string[]): void => {
  //   dispatch(setSelectedInstances(nextTargetKeys));
  // };

  // const triggerDisable = (checked: boolean): void => {
  //   setDisabled(checked);
  // };

  // const triggerShowSearch = (checked: boolean): void => {
  //   setShowSearch(checked);
  // };
  const dispatch = useAppDispatch();

  const instances = useAppSelector(selectMidservicesList);

  useEffect(() => {
    if (networkId != null && domain != null) {
      const filter: Record<string, FilterValue | null> = {
        network: [networkId],
        instanceType: ["MIDSERVICE"],
        domain: [domain],
      };
      console.log("InstancesTransfer", domain, networkId);

      console.log("InstancesTransfer filters", filter);
      const instancesListParams: PaginationParams = {
        page: 1,
        limit: 10000000,
        filter: filtersToQueryString(filter),
        // search: inputV,
      };
      dispatch(midserviceInstansesListAsync(instancesListParams));
    }
  }, [networkId, domain]);

  return (
    <>
      <TableTransfer
        dataSource={instances.content}
        targetKeys={value}
        currentConfigHash={currentConfiguration?.configHash}
        packetConfigId={currentConfiguration?.id}
        // disabled={disabled}
        showSearch={true}
        onChange={onChange}
        filterOption={(inputValue, item) =>
          item.name?.includes(inputValue.toLowerCase()) ||
          item.deviceId?.toLowerCase()?.includes(inputValue.toLowerCase()) ||
          item.version?.toLowerCase()?.includes(inputValue.toLowerCase()) ||
          item.address?.toLowerCase()?.includes(inputValue.toLowerCase())
        }
        leftColumns={columns}
        rightColumns={columns}
        titles={["Полный список", "Выбранные"]}
        locale={{
          itemUnit: "device",
          itemsUnit: "devices",
          notFoundContent: "Список пуст",
          searchPlaceholder: "Поиск устройств",
        }}
      />
    </>
  );
};
